import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { ApplyResetComponent } from './components/apply-reset/apply-reset.component'
import { AuthContainerComponent } from './components/auth-container/auth-container.component'
import { LoginComponent } from './components/login/login.component'
import { ResetPasswordComponent } from './components/reset-password/reset-password.component'
import { ValidatePinComponent } from './components/validate-pin/validate-pin.component'
import { SamlCallbackComponent } from './components/saml-callback/saml-callback.component'
const routes: Routes = [
  {
    path: '',
    component: AuthContainerComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
      },
      {
        path: 'validate-pin',
        component: ValidatePinComponent,
      },
      {
        path: 'validate-pin/:isVerify',
        component: ValidatePinComponent,
      },
      {
        path: 'apply-reset',
        component: ApplyResetComponent,
      },
      {
        path: 'saml/callback',
        component: SamlCallbackComponent,
      },
    ],
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
